<template>
    <el-main class="container">
        <div class="form-box">
            <el-form ref="queryFormRef" :model="queryForm" size="small" :inline="true">
                <el-form-item label="上传日期" prop="billDate.selected">
                    <date-picker class="query_form_item" style="width: 240px;" v-model="queryForm.billDate.selected" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                    </date-picker>
                </el-form-item>
                <el-form-item label="标题" prop="title.selected">
                    <el-input style="width: 180px;" placeholder="输入" v-model="queryForm.title.selected" clearable></el-input>
                </el-form-item>
                <el-form-item label="上传人" prop="entryUser.selected">
                    <select-multiple style="width: 180px;" class="query_form_item" :select-data="queryForm.entryUser"></select-multiple>
                </el-form-item>
                <el-form-item label="状态" prop="status.selected">
                    <el-select style="width: 180px;" v-model="queryForm.status.selected" placeholder="请选择">
                        <el-option v-for="item in queryForm.status.list" :key="item.value" :label="item.text" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="模块" prop="model.selected">
                    <select-multiple style="width: 180px;" class="query_form_item" :select-data="queryForm.model"></select-multiple>
                </el-form-item>
                <el-form-item style="text-align: center;">
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                    <el-button @click="onReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="box" :style="{height: boxHeight + 'px'}">
            <div class="left-box">
                <div class="table-box">
                    <el-table :data="tableData" ref="table" size="mini" v-loading="tableIsLoading" border stripe height="100%" max-height="100%">
                        <el-table-column type="index" align="center" width="40" :index="indexMethod">
                        </el-table-column>
                        <el-table-column prop="billPic" align="center" label="海报预览">
                            <template slot-scope="{ row }">
                                <el-image style="width: 80px; height: 138px; display: block; margin: 0 auto" :src="row.billPic" :preview-src-list="row.list" fit="cover">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="title" align="center" label="相关信息">
                            <template slot-scope="{ row }">
                                <div class="row">
                                    <p><span>标题：</span>{{row.title}}</p>
                                    <p><span>模块：</span>{{row.modelId}}</p>
                                    <p><span>上传人：</span>{{row.entryUserName}}</p>
                                    <p><span>上传时间：</span>{{row.entryDate}}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" align="center" label="状态">
                            <template slot-scope="{ row }">
                                <div class="button" :class="row.status == 1 ? 'status' : ''" @click="toChangeStatus(row)">{{row.status == 1 ? '已下架' : '已上架'}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" align="center" label="操作">
                            <template slot-scope="{ row }">
                                <el-button v-if="row.status == 1" type="text" icon="el-icon-delete" class="delete" @click="deleteImg(row)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="paginationArgs.page" :page-sizes="[10, 20, 100]" :page-size="paginationArgs.rows" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
            <el-aside style="width: 35%; height: 100%;">
                <el-form ref="addFormRef" :model="addForm" size="small" style="margin-top: 50px;">
                    <el-form-item prop="file">
                        <el-upload class="upload-demo" :class="choosed ? 'none' : ''" list-type="picture-card" drag action="#" :auto-upload="false" :limit="1" :on-change="handleChange" :on-remove="handleRemove" ref="upload">
                            <template slot="default" v-if="!choosed">
                                <p>将图片拖到此处或点击选择<br />仅支持上传jpg/png格式文件<br />单个文件不能超过500kb</p>
                                <div class="upload-btn">点击上传</div>
                            </template>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="标题" prop="title" style="display: flex; justify-content: center;">
                        <el-input style="width: 250px;" placeholder="请输入" v-model="addForm.title" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="模块" prop="model.selected" style="display: flex; justify-content: center;">
                        <select-multiple style="width: 250px;" class="query_form_item" :select-data="addForm.model"></select-multiple>
                    </el-form-item>
                    <el-form-item style="text-align: center;">
                        <el-button @click="onAddReset">取消</el-button>
                        <el-button type="primary" @click="onAddSubmit">确定</el-button>
                    </el-form-item>
                </el-form>
            </el-aside>
        </div>
    </el-main>
</template>
<script>
import datePicker from '@/components/common/datePicker.vue'
import { pickerOptions, getAddDate, getNowFormatDate, toRawType } from '@/assets/js/common.js'
export default {
    name: 'PosterManagement',
    components: {
        datePicker,
    },
    data() {
        let beginDate = getAddDate(-30)
        let endDate = getNowFormatDate()
        return {
            queryForm: {
                entryUser: { submitName: 'entryUserID', selected: [], valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择上传人', request: { url: '/Account/monitorCenterEnterDefine/selectCrmUserList.html', type: 'post', params: { page: 1, size: 5 }, text: 'accountName', value: 'id' } },
                model: { submitName: 'modelId', selected: [], valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择模板', request: { url: '/Account/monitorCenterEnterDefine/selectModelList.html', type: 'post', params: { page: 1, size: 5 }, text: 'modelId', value: 'modelId' } },
                billDate: { submitName: 'billDate', selected: [beginDate, endDate] },
                status: { submitName: 'status', selected: '', list: [{ value: '', text: '全部' }, { value: '0', text: '上架' }, { value: '1', text: '下架' }] },
                title: { submitName: 'title', selected: '' }
            },
            pickerOptions: pickerOptions,
            tableData: [],
            tableIsLoading: false,
            paginationArgs: {
                page: 1,
                rows: 20,
            },
            total: 0,
            boxHeight: 0,
            addForm: {
                model: { submitName: 'modelId', selected: [], valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择模板', request: { url: '/Account/monitorCenterEnterDefine/selectModelList.html', type: 'post', params: { page: 1, size: 5 }, text: 'modelId', value: 'modelId' } },
                title: '',
                fill: {}
            },
            choosed: false,
        }
    },
    created() {
        this.getTableList()
    },
    mounted() {
        this.onresize()
        window.addEventListener('resize', () => this.onresize(), false)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onresize(), false)
    },
    computed: {
        queryItem() {
            let tempItem = {}
            Object.values(this.queryForm).forEach(item => {
                if (toRawType(item.selected) == 'Array') {
                    if (item.submitName == 'billDate') {
                        tempItem['beginSearchDate'] = item.selected[0] || ''
                        tempItem['endSearchDate'] = item.selected[1] || ''
                        return false
                    }
                    tempItem[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
                } else if (toRawType(item.selected) == 'String') {
                    tempItem[item.submitName] = item.selected || ''
                } else if (toRawType(item.selected) == 'Object') {
                    tempItem[item.submitName] = item.selected.value || ''
                }
            })
            return tempItem
        }
    },
    methods: {
        onresize() {
            // this.$refs.table.doLayout()
            this.boxHeight = parseInt(Number($(".container").height()) - Number($(".form-box").height()) - 6)
        },
        async getTableList() {
            this.tableIsLoading = true
            try {
                const { data: res } = await this.$http.post('/Account/monitorCenterEnterDefine/selectBillPicList.html', this.Qs.stringify({ ...this.queryItem, ...this.paginationArgs }))
                this.tableIsLoading = false
                if (res.code != 'success') return this.$message.error(res.message)
                let { total, data } = JSON.parse(res.result)
                this.total = total
                this.tableData = JSON.parse(data).map(item => {
                    item.list = []
                    item.list.push(item.billPic)
                    return item
                })
                console.log(this.tableData)
            } catch (e) {
                console.log(e)
                this.tableIsLoading = false
            }
        },
        indexMethod(index) {
            return ((this.paginationArgs.page - 1) * this.paginationArgs.rows) + (index + 1)
        },
        // 监听pagesize的改变
        handleSizeChange(newSize) {
            this.paginationArgs.rows = newSize
            this.getTableList()
        },
        // 监听页码值的改变
        handleCurrentChange(newPage) {
            this.paginationArgs.page = newPage
            this.getTableList()
        },
        onSubmit() {
            this.paginationArgs.page = 1
            this.getTableList()
        },
        onReset() {
            this.$refs.queryFormRef.resetFields()
            this.paginationArgs.page = 1
            this.getTableList()
        },
        async toChangeStatus({ id, status }) {
            let word = status == 0 ? '下架' : '上架'
            const confirmResult = await this.$confirm('此操作为' + word + '操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return false
            const loading = this.$loading({
                lock: true,
                text: word + '中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let url = '/Account/monitorCenterEnterDefine/updateBillPicStatus.html'
            const { data: res } = await this.$http.post(url, this.Qs.stringify({ id: id, status: status == 0 ? 1 : 0 }))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            this.getTableList()
        },
        async deleteImg({ id }) {
            const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return false
            const loading = this.$loading({
                lock: true,
                text: '删除中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let url = '/Account/monitorCenterEnterDefine/deleteById.html'
            const { data: res } = await this.$http.post(url, this.Qs.stringify({ id: id }))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            this.getTableList()
        },
        handleChange(file) {
            console.log(file);
            const raw = file.raw
            const isJPG = raw.type === 'image/jpeg' || raw.type === 'image/png';
            const isLt2M = raw.size / 1024 < 500;
            if (!isJPG) {
                this.$refs.upload.clearFiles()
                this.addForm.file = {}
                this.choosed = false
                return this.$message.error('上传图片只能是 JPG/PNG 格式!');
            }
            if (!isLt2M) {
                this.$refs.upload.clearFiles()
                this.addForm.file = {}
                this.choosed = false
                return this.$message.error('上传图片大小不能超过 500KB!');
            }
            this.addForm.file = file
            this.choosed = true
        },
        handleRemove(file) {
            console.log(file);
            this.addForm.file = {}
            this.choosed = false
        },
        async onAddSubmit() {
            console.log(this.addForm.file)
            if (!this.addForm.file.url) return this.$message.error('请选择图片')
            if (!this.addForm.title) return this.$message.error('请填写标题')
            if (!this.addForm.model.selected.value) return this.$message.error('请选择模板')
            let obj = {
                title: this.addForm.title,
                modelId: this.addForm.model.selected.value
            }
            const loading = this.$loading({
                lock: true,
                text: '上传图片中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            var formData = new FormData();
            delete this.addForm.file.url.uid
            formData.append("file", this.addForm.file.raw);
            console.log(formData)
            const { data: res } = await this.$http.post('/android/AcceptPictureServlet2', formData)
            console.log(res)
            if (res.code == 'ERROR') {
                loading.close()
                return this.$message.error('图片上传错误')
            }
            obj.billPic = res.result
            // this.onSubmitInfo()
            console.log(obj)
            const { data: ret } = await this.$http.post('/Account/monitorCenterEnterDefine/addBillPic.html', this.Qs.stringify(obj))
            loading.close()
            if (ret.code != 'success') return this.$message.error(ret.message)
            this.$message.success(ret.message)
            this.paginationArgs.page = 1
            this.getTableList()
            this.onAddReset()
        },
        onAddReset() {
            this.$refs.addFormRef.resetFields()
            this.$refs.upload.clearFiles()
            this.addForm.file = {}
            this.choosed = false
        }
    }
}
</script>
<style lang="less" scoped>
.el-main {
    padding: 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.form-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    .el-form-item {
        margin-bottom: 12px;
    }
}

.box {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;

    .left-box {
        flex: 1;
        height: 100%;

        .table-box {
            height: calc(100% - 32px);

            .el-table {
                flex: 1;

                ::v-deep .el-table__body {
                    .row {

                        p {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            span {
                                width: 62px;
                                display: inline-block;
                                text-align: left;
                            }
                        }
                    }

                    .button {
                        width: 120px;
                        height: 32px;
                        text-align: center;
                        color: #2A82E4;
                        font-size: 14px;
                        border-radius: 4px;
                        border: 1px solid #2A82E4;
                        line-height: 32px;
                        margin: 0 auto;
                        cursor: pointer;

                        &.status {
                            background-color: #2A82E4;
                            color: #FFFFFF;
                        }
                    }

                    .delete {
                        font-size: 20px;
                        padding: 0;
                    }
                }
            }
        }
    }

    .el-aside {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        ::v-deep .el-upload {
            width: 360px;
            height: 340px;
            position: relative;
            border: none;

            .el-upload-dragger {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 340px;

                p {
                    font-size: 12px;
                    color: #A6A6A6;
                    line-height: 28px;
                }

                .upload-btn {
                    width: 120px;
                    height: 32px;
                    text-align: center;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 32px;
                    border-radius: 4px;
                    background: #2A82E4;
                    margin-top: 50px;
                }
            }
        }

        ::v-deep .el-upload-list {
            width: 360px;
            height: 340px;
            background-color: #fbfdff;
            border: 1px dashed #c0ccda;
            border-radius: 6px;
            box-sizing: border-box;
            cursor: pointer;
            line-height: 146px;
            vertical-align: top;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            z-index: 0;
            opacity: 0;

            li {
                display: block;
                margin: 0 auto;
                width: 200px;
                height: auto;
                border: none;

                img {
                    width: 200px;
                    height: auto;
                    display: block;
                }
            }
        }


        .none {
            ::v-deep .el-upload--picture-card {
                z-index: 1;
            }

            ::v-deep .el-upload-list {
                z-index: 2;
                opacity: 1;
            }
        }
    }
}
</style>